
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as indexkMXq_IPo4pKkO9zPxBvWaAXSyM9Gr1hkNAi1REr6V1MMeta } from "/app/pages/voix/menus/index.vue?macro=true";
import { default as index_45Tc7Nv361vyKBbb1vUAgDp6bP8dCEdckoyhlpHR624YMeta } from "/app/pages/voix/posts/index.vue?macro=true";
import { default as indexPYd0qKEMFRMc2jkApm8LX4lyZ4D4XSk8iR3cv0OsAnQMeta } from "/app/pages/voix/brands/index.vue?macro=true";
import { default as indexeyK3SWmHKp1NK9aLF1Sd4eb_B5MRCs9CxKFb2UpGWR0Meta } from "/app/pages/voix/caches/index.vue?macro=true";
import { default as createU_45KEuQii0c3Xnmd48Iztra9F3IRqZK3H5RjG7KgVX0wMeta } from "/app/pages/voix/menus/create.vue?macro=true";
import { default as createI2hnVvhPTyMROr8XR_R_45_45GSTD4LJO8N2efMl8i_KtoQMeta } from "/app/pages/voix/posts/create.vue?macro=true";
import { default as createW0G_45yEsZJjyYr0eRAe_8xjx5elHPRCdLUvKO8V4wpDUMeta } from "/app/pages/voix/brands/create.vue?macro=true";
import { default as indexr7ATTRyevCdv_455jAeRSMTk1XvlKNluueRBoa_45yfJeZ4Meta } from "/app/pages/voix/resorts/index.vue?macro=true";
import { default as create3DaCdetFb7YuXVbCg1Xc4Krxu5350lLeGZuqBRCMPHMMeta } from "/app/pages/voix/resorts/create.vue?macro=true";
import { default as indexH0Dgk_45ZcrU0gkAmfsfxMYCiLo833wSxtofqdasXz6ucMeta } from "/app/pages/voix/specials/index.vue?macro=true";
import { default as _91id_93y_VWPMT0fIq64fpriHXaAydo34bdIPbKN1JQHLmTsMsMeta } from "/app/pages/voix/menus/edit/[id].vue?macro=true";
import { default as _91id_93bv7tdJfS7Lnr3idO_zuR3CSzjQ9IR44vXvGbKLuXBZcMeta } from "/app/pages/voix/posts/edit/[id].vue?macro=true";
import { default as createwlb_45xqM8R2OVY_45g_tq9G8G6uqjRIL9X8kguUj6Y8P94Meta } from "/app/pages/voix/specials/create.vue?macro=true";
import { default as _91id_93JJJV_qnKNC6uq64zjs6BOMTlsMPlsgHdh0X4OH8GpFMMeta } from "/app/pages/voix/brands/edit/[id].vue?macro=true";
import { default as indextt6apscB2gcGAJwwG20BCDdbFu1rUf5bIryCby7dZXkMeta } from "/app/pages/voix/fact-sheets/index.vue?macro=true";
import { default as _91id_93scj8_45O5loK_45zXm1c_45WNb8wTLy5g9DxQ467jV2DmHt4gMeta } from "/app/pages/voix/resorts/edit/[id].vue?macro=true";
import { default as index4qViqkal731Dl6imJ7DtWUQs6yBicJNJ42OSU7pI_45w4Meta } from "/app/pages/voix/style-guide/index.vue?macro=true";
import { default as createcEgiz_o_45X7mI8_45lxEDuAd0uwUkxfQJiZglPd6g2GsW4Meta } from "/app/pages/voix/fact-sheets/create.vue?macro=true";
import { default as _91id_93l0_WumgP0k9YNMh5_45elfu8UMomZ9E9STpvWNfUTfOMQMeta } from "/app/pages/voix/specials/copy/[id].vue?macro=true";
import { default as _91id_93SfhwB_45lzuDIypuqbJW5deaoZABaXcve50Qn4V_ZW0noMeta } from "/app/pages/voix/specials/edit/[id].vue?macro=true";
import { default as _91id_93fr7A3QL_23ZYuZxJaHNHm9r0r_mHLT8_45HAzlFG5d_5AMeta } from "/app/pages/voix/fact-sheets/edit/[id].vue?macro=true";
import { default as indexP69QqrCINnaeRthJPMlMz9B2o14roCDRRQP7wR2YWA8Meta } from "/app/pages/voix/booking-code-triggers/index.vue?macro=true";
import { default as createPDPlx7Le5nj5I1hZJTxIZPyHH5bB9av8unHmTeGGjQkMeta } from "/app/pages/voix/booking-code-triggers/create.vue?macro=true";
import { default as _91id_93_7RZSobC0ia611a_K_454mwJ7BFHkZ2GTIlwj0uxK52LYMeta } from "/app/pages/voix/booking-code-triggers/edit/[id].vue?macro=true";
import { default as voix_45debughTo3Mb116y_45VxTViAeK_45ZwAejqnmSZ3EUWpC96XJGY8Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue?macro=true";
import { default as Preview4_45rAAFIWyws9qkDkwIDOK9K4wXKHFjy3cjJPcJaUc_45sMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue?macro=true";
import { default as IndexY_451K8SPHfcz_zKcZqXYqYtTwlWX0IXEISM3_45VOcAVhEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue?macro=true";
import { default as loginQDNAVwH3wM8Ri4EJLqH0Fn1tNZG0l5ZPs7blebA2v_450Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue?macro=true";
import { default as callback_45p8rbXre3l8I8YT3SwcFxfaz99w2Uj91NNwkJc9lyqwMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue?macro=true";
import { default as studioScNna8e7pCr9bpZxYHA6B7hr_ac6vx6QFn1zL1We5CYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue?macro=true";
import { default as IndexkGjX5bs_Yp_45HOioL9g89szaEqQjVAETSrbtrohQSl_45AMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue?macro=true";
import { default as EditexIE5S9DXU17hzuOOeubytOZ4TH3maBRxrD0S3fTUTYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue?macro=true";
import { default as CreateSnDwOAvIRpv_PFYTY3K95YoM_eS0yJxApm94q38UxYEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue?macro=true";
import { default as IndexJGeGwuNvRF0gQlnd5ngrMjY_458WzcTRXE6AdvVsiiA2UMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue?macro=true";
import { default as CreateW8_x9LGsR_SlgkSR0GcsjAhS3j2r0JLRlg0xLCGCbkEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue?macro=true";
import { default as TranslateF5Jk58glG00pBR5hIXrHwnbcKBoqao7SMqSfLYLBPewMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue?macro=true";
import { default as CopyEUL_2fsv8Wmh1qouzUcNmuLDuTiMtZHVx9Sjr9jqIcIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue?macro=true";
import { default as Index2Lsn5xRwHX5PcWVmS0fqDKGm6McYup_458vwwGbXF6jooMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue?macro=true";
import { default as IndexyF_459RFOUCc7ufe0eVBzLWKsjJsMHSRiWCbWRylIwOukMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue?macro=true";
import { default as EditnMVQ5s9wavU237CmxcnX8HA3jNGvTiDL5H54_UwOCLMMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue?macro=true";
import { default as CreateKFARmfeuzd8cHso3PRDBkKw9qhLiuVHTEpuorQe4_45hoMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue?macro=true";
import { default as IndexqDeby6KETb7HoR8SGW_45sWNz_ap7qXzvEvlQz0AmloJ4Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue?macro=true";
import { default as Create0_45dbNgR1qcgrUzydW27UpUpuTFR6VBBi1k9xUXWg4q4Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue?macro=true";
import { default as EditESJwGnQfvyZfc30oCL77DlOxTj5GgVAp_45yFIHjWr6rAMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue?macro=true";
import { default as Profile_rbboNFifXkd9lONxewBMBjAqj_eepI4KPcMUWicUxIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue?macro=true";
import { default as indexDGW7LT7ueI2WsHgpn5h4V1h3lOqDQHf03vXsxwp9cOkMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue?macro=true";
import { default as SlicesView4rCEuQAXFTb2enL6UABf8aV_45lJexzMJ_45afUZHPto7uQMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue?macro=true";
import { default as TemplateViewtE2VfxbKQlGHHVE6mkHe4t_45q7X_45sWSAjVrEH1vdcSvQMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue?macro=true";
import { default as DesignGuideView6Eiyh_45QaaRWwEpuGs584mlwlVmyScBbDOLNIvlpXTCYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue?macro=true";
import { default as slicervsyJtFEqWu7wT4oFe5UEaqUFjqTqMhILMWfkk6T7a_45gMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue?macro=true";
import { default as documentQIzUAlgJBPvzMl6Q3aJDEvztl_454QEm5k9NXrB15dG48Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue?macro=true";
import { default as voixNYDGR87sCigZAgl8cNO9VjzF2dGGa6aVqPyNTpVZVyEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue?macro=true";
import { default as SlicePreviewJLc3u2hcsx7xCRAHvW42OTjWrnxIMBqW2KbmqDFO260Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue?macro=true";
import { default as previewFaoL3Fw88qmVd3fnv0YMevz2mfW_2Tj3q800hY4W6zIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "voix-menus",
    path: "/voix/menus",
    component: () => import("/app/pages/voix/menus/index.vue")
  },
  {
    name: "voix-posts",
    path: "/voix/posts",
    component: () => import("/app/pages/voix/posts/index.vue")
  },
  {
    name: "voix-brands",
    path: "/voix/brands",
    component: () => import("/app/pages/voix/brands/index.vue")
  },
  {
    name: "voix-caches",
    path: "/voix/caches",
    component: () => import("/app/pages/voix/caches/index.vue")
  },
  {
    name: "voix-menus-create",
    path: "/voix/menus/create",
    component: () => import("/app/pages/voix/menus/create.vue")
  },
  {
    name: "voix-posts-create",
    path: "/voix/posts/create",
    component: () => import("/app/pages/voix/posts/create.vue")
  },
  {
    name: "voix-brands-create",
    path: "/voix/brands/create",
    component: () => import("/app/pages/voix/brands/create.vue")
  },
  {
    name: "voix-resorts",
    path: "/voix/resorts",
    component: () => import("/app/pages/voix/resorts/index.vue")
  },
  {
    name: "voix-resorts-create",
    path: "/voix/resorts/create",
    component: () => import("/app/pages/voix/resorts/create.vue")
  },
  {
    name: "voix-specials",
    path: "/voix/specials",
    component: () => import("/app/pages/voix/specials/index.vue")
  },
  {
    name: "voix-menus-edit-id",
    path: "/voix/menus/edit/:id()",
    component: () => import("/app/pages/voix/menus/edit/[id].vue")
  },
  {
    name: "voix-posts-edit-id",
    path: "/voix/posts/edit/:id()",
    component: () => import("/app/pages/voix/posts/edit/[id].vue")
  },
  {
    name: "voix-specials-create",
    path: "/voix/specials/create",
    component: () => import("/app/pages/voix/specials/create.vue")
  },
  {
    name: "voix-brands-edit-id",
    path: "/voix/brands/edit/:id()",
    component: () => import("/app/pages/voix/brands/edit/[id].vue")
  },
  {
    name: "voix-fact-sheets",
    path: "/voix/fact-sheets",
    component: () => import("/app/pages/voix/fact-sheets/index.vue")
  },
  {
    name: "voix-resorts-edit-id",
    path: "/voix/resorts/edit/:id()",
    component: () => import("/app/pages/voix/resorts/edit/[id].vue")
  },
  {
    name: "voix-style-guide",
    path: "/voix/style-guide",
    component: () => import("/app/pages/voix/style-guide/index.vue")
  },
  {
    name: "voix-fact-sheets-create",
    path: "/voix/fact-sheets/create",
    component: () => import("/app/pages/voix/fact-sheets/create.vue")
  },
  {
    name: "voix-specials-copy-id",
    path: "/voix/specials/copy/:id()",
    component: () => import("/app/pages/voix/specials/copy/[id].vue")
  },
  {
    name: "voix-specials-edit-id",
    path: "/voix/specials/edit/:id()",
    component: () => import("/app/pages/voix/specials/edit/[id].vue")
  },
  {
    name: "voix-fact-sheets-edit-id",
    path: "/voix/fact-sheets/edit/:id()",
    component: () => import("/app/pages/voix/fact-sheets/edit/[id].vue")
  },
  {
    name: "voix-booking-code-triggers",
    path: "/voix/booking-code-triggers",
    component: () => import("/app/pages/voix/booking-code-triggers/index.vue")
  },
  {
    name: "voix-booking-code-triggers-create",
    path: "/voix/booking-code-triggers/create",
    component: () => import("/app/pages/voix/booking-code-triggers/create.vue")
  },
  {
    name: "voix-booking-code-triggers-edit-id",
    path: "/voix/booking-code-triggers/edit/:id()",
    component: () => import("/app/pages/voix/booking-code-triggers/edit/[id].vue")
  },
  {
    name: "voix-debug",
    path: "/voix-debug",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue")
  },
  {
    name: "voix-preview-release-entry-en",
    path: "/preview-release/:releaseId/:previewSecret",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue")
  },
  {
    name: "voix",
    path: "/voix",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue"),
    children: [
  {
    name: "voix-settings-en",
    path: "",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue")
  },
  {
    name: "voix-login-en",
    path: "login",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue")
  },
  {
    name: "voix-auth-callback-en",
    path: "auth/callback",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue")
  },
  {
    name: "voix-studio-en",
    path: "studio",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue")
  },
  {
    name: "voix-settings-head-tags-en",
    path: "head-tags",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue")
  },
  {
    name: "voix-settings-head-tags-edit-en",
    path: "head-tags/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue")
  },
  {
    name: "voix-settings-head-tags-create-en",
    path: "head-tags/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue")
  },
  {
    name: "voix-settings-pages-en",
    path: "pages",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue")
  },
  {
    name: "voix-settings-pages-create-en",
    path: "pages/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue")
  },
  {
    name: "voix-settings-pages-translate-en",
    path: "pages/translate",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue")
  },
  {
    name: "voix-settings-pages-copy-en",
    path: "pages/copy",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue")
  },
  {
    name: "voix-settings-releases-en",
    path: "releases",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue")
  },
  {
    name: "voix-settings-redirects-en",
    path: "redirects",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue")
  },
  {
    name: "voix-settings-redirects-edit-en",
    path: "redirects/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue")
  },
  {
    name: "voix-settings-redirects-create-en",
    path: "redirects/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue")
  },
  {
    name: "voix-settings-users-en",
    path: "users",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue")
  },
  {
    name: "voix-settings-users-create-en",
    path: "users/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue")
  },
  {
    name: "voix-settings-users-edit-en",
    path: "users/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue")
  },
  {
    name: "voix-settings-users-profile-en",
    path: "profile",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue")
  },
  {
    name: "voix-cookbook-en",
    path: "cookbook",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue")
  },
  {
    name: "voix-slicer-en",
    path: "slicer",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue"),
    children: [
  {
    name: "voix-slicer-slices-en",
    path: "",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue")
  },
  {
    name: "voix-slicer-template-en",
    path: "templates/:templateName",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue")
  },
  {
    name: "voix-slicer-design-guide-en",
    path: "design-guide",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue")
  }
]
  },
  {
    name: "voix-documentation-en",
    path: "documentation/:documentPath(.*)?",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue")
  }
]
  },
  {
    name: "slicer-slice-en",
    path: "/voix/slice-preview/:sliceName",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue")
  },
  {
    name: "cookbook-preview-en",
    path: "/voix/cookbook-preview/:recipe(.*)",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue")
  }
]